/**
 * Home Banner - Carousel com troca automática a cada X segundos
 */
(function () {
  function initHomeBanner(scope) {
    const carousels = scope.querySelectorAll('[data-home-banner-carousel]');

    carousels.forEach((slidesContainer) => {
      const section = slidesContainer.closest('.home-banner');
      if (!section) return;

      const slides = slidesContainer.querySelectorAll('.home-banner__slide');
      const dotsContainer = section.querySelector('[data-home-banner-dots]');
      const dots = dotsContainer
        ? dotsContainer.querySelectorAll('.home-banner__dot')
        : [];

      if (slides.length <= 1) return;

      const autoplaySeconds =
        parseFloat(
          getComputedStyle(section).getPropertyValue('--home-banner-autoplay')
        ) || 3;
      let currentIndex = 0;
      let autoplayTimer = null;

      function goToSlide(index) {
        currentIndex = ((index % slides.length) + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          slide.classList.toggle('home-banner__slide--active', i === currentIndex);
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('home-banner__dot--active', i === currentIndex);
        });

        resetAutoplay();
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function resetAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = setInterval(nextSlide, autoplaySeconds * 1000);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(index);
        });
      });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', resetAutoplay);

      resetAutoplay();
    });
  }

  function init() {
    initHomeBanner(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHomeBanner(event.target);
  });
})();
